// CalendarViewModeSelector.js - FIXED: Prevents page refresh
import React from 'react';
import { Calendar, Square, Grid } from 'lucide-react';

const CalendarViewModeSelector = ({ viewMode, onViewModeChange, className = "" }) => {
  const viewModes = [
    { mode: 'day', icon: Calendar, label: 'Day' },
    { mode: 'week', icon: Square, label: 'Week' },
    { mode: 'month', icon: Grid, label: 'Month' }
  ];

  // CRITICAL FIX: Prevent default and stop propagation
  const handleClick = (e, mode) => {
    e.preventDefault();
    e.stopPropagation();
    onViewModeChange(mode);
  };

  return (
    <div className={`flex items-center bg-slate-100 rounded-lg p-1 ${className}`}>
      {viewModes.map(({ mode, icon: Icon, label }) => (
        <button
          key={mode}
          type="button"
          onClick={(e) => handleClick(e, mode)}
          className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${
            viewMode === mode
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-slate-600 hover:text-slate-800'
          }`}
        >
          <Icon className="w-4 h-4" />
          <span className="text-sm font-medium">{label}</span>
        </button>
      ))}
    </div>
  );
};

export default CalendarViewModeSelector;